export default "__VITE_ASSET__BPa6Ps7z__"